import type {
  ConflictPolicyConfig,
  EnrichmentConfig,
  MatchingConfig,
  NormalizationConfig,
  PostImportActionsConfig,
} from './types';

/**
 * Valeurs par défaut alignées sur les DTO V2 (CreateDeploymentInput et ses
 * sous-configs). Permet d'exposer tout le contrat avec des défauts sûrs.
 */

export const DEFAULT_CONFLICT_POLICY: ConflictPolicyConfig = {
  studentsPolicy: 'skip',
  teachersPolicy: 'skip',
  parentsPolicy: 'skip',
  directorsPolicy: 'skip',
  subjectsPolicy: 'skip',
  classesPolicy: 'skip',
  treatBatchDuplicatesAsSkip: true,
};

export const DEFAULT_MATCHING: MatchingConfig = {
  parentToStudentStrategy: 'email',
  studentToClassStrategy: 'class_name',
  teacherToSubjectStrategy: 'specialty_name',
  failOnOrphans: false,
  maxOrphansAllowed: 0,
  caseInsensitive: true,
};

export const DEFAULT_NORMALIZATION: NormalizationConfig = {
  emailMode: 'lowercase',
  nameMode: 'title_case',
  phoneMode: 'digits_only',
  dateFormats: ['Y-m-d', 'd/m/Y', 'd-m-Y', 'Y/m/d'],
  defaultPhoneCountry: 'FR',
  trimInternalSpaces: true,
  stripBom: true,
  normalizeUnicodeAccents: false,
};

export const DEFAULT_ENRICHMENT: EnrichmentConfig = {
  generateMissingEmail: false,
  emailTemplate: '{firstname}.{lastname}@{tenantDomain}',
  tenantDomain: 'ef-school.local',
  generateStudentId: false,
  studentIdPattern: 'STU-{year}-{counter:5}',
  generateTempPassword: false,
  tempPasswordLength: 12,
  computeAgeFromBirthdate: false,
  generateAvatarFromGravatar: false,
  defaultValues: {},
};

export const DEFAULT_POST_IMPORT: PostImportActionsConfig = {
  runCommands: [],
  createMissingClassrooms: false,
  createDefaultGroups: false,
  clearCache: false,
  commandTimeoutSeconds: 60,
  stopOnCommandFailure: false,
};

export interface WizardConfig {
  csvDelimiter: import('./types').CsvDelimiter;
  encoding: import('./types').Encoding;
  skipHeaderRow: boolean;
  batchSize: number;
  stopOnError: boolean;
  skipDuplicates: boolean;
  notifyOnCompletion: boolean;
  conflictPolicy: ConflictPolicyConfig;
  matching: MatchingConfig;
  normalization: NormalizationConfig;
  enrichment: EnrichmentConfig;
  postImport: PostImportActionsConfig;
}

export const DEFAULT_WIZARD_CONFIG: WizardConfig = {
  csvDelimiter: ';',
  encoding: 'UTF-8',
  skipHeaderRow: true,
  batchSize: 500,
  stopOnError: false,
  skipDuplicates: true,
  notifyOnCompletion: true,
  conflictPolicy: DEFAULT_CONFLICT_POLICY,
  matching: DEFAULT_MATCHING,
  normalization: DEFAULT_NORMALIZATION,
  enrichment: DEFAULT_ENRICHMENT,
  postImport: DEFAULT_POST_IMPORT,
};
